import { useEffect, useState } from "react";
import FormRegisterProvider from "./component/FormRegisterProvider";
import { getUser } from "../../config/LiveApi";
import { useSelector } from "react-redux";

function index() {
  const [listofusers, setListofUser] = useState(null);
  const token = useSelector((store) => store.userReducer.token);

  const fetchUsers = async (page) => {
    try {
      const response = await getUser(token);
      const data = response?.data;

      const adminUsers = data.filter((user) => user.role === "admin");

      setListofUser(adminUsers);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div>
      <FormRegisterProvider listofusers={listofusers} />
    </div>
  );
}

export default index;